







































	import {Emit} from "vue-property-decorator";
	import {InOut} from 'vue-inout-prop-decorator';
	import {Component, Vue} from '@/shared/component';

	import {Locataire} from '@/models';

	import CrudLocataireEditLocataire from '@/components/Crud/Locataire/EditLocataire.vue';
	import storeLocataire from "@/stores/modules/locataire";

	@Component({
		components: {
			CrudLocataireEditLocataire,
		}
	})
	export default class CrudLocataireEditLocataireDialog extends Vue {
		@InOut({ type: Locataire  , isVModel: true }) private value!: Locataire;

		@Emit()
		private onSubmit(locataire: Locataire) {
			this.onClose();
		}

		@Emit()
		private async onClose(): Promise<void> {
			this.value = null;
		}

}
